import { PhoneCallDirection } from './phone-call-direction.enum';
import { PhoneCallStatus } from './phone-call-status.enum';
var PhoneChannelDataBuilder = /** @class */ (function () {
    function PhoneChannelDataBuilder() {
        this.phoneChannelData = {
            callId: '213123',
            phoneNumber: { id: 'bla', number: '+9721800400400', status: 1 },
            timeSlot: {
                startDate: Date.now() - 1800000,
                endDate: Date.now()
            },
            timeSlotStartDate: Date.now(),
            timeSlotEndDate: Date.now() + 180000,
            direction: PhoneCallDirection.SCHEDULED,
            callStatus: PhoneCallStatus.PENDING,
            recordingUrls: [],
            waitTime: [],
            callDuration: 5,
            timeZone: 'GMT',
            startTime: Date.now() - 18000,
            endTime: Date.now()
        };
    }
    PhoneChannelDataBuilder.prototype.withCallId = function (callId) {
        this.phoneChannelData.callId = callId;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withPhoneNumber = function (phoneNumber) {
        this.phoneChannelData.phoneNumber = { id: '1', number: phoneNumber, status: 2 };
        return this;
    };
    PhoneChannelDataBuilder.prototype.withTimeSlot = function (timeSlot) {
        this.phoneChannelData.timeSlot = timeSlot;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withTimeSlotStartDate = function (time) {
        this.phoneChannelData.timeSlotStartDate = time;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withTimeSlotEndDate = function (time) {
        this.phoneChannelData.timeSlotEndDate = time;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withCallStatus = function (callStatus) {
        this.phoneChannelData.callStatus = callStatus;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withDirection = function (direction) {
        this.phoneChannelData.direction = direction;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withRecordingUrls = function (recordingUrls) {
        this.phoneChannelData.recordingUrls = recordingUrls;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withWaitTime = function (waitTime) {
        this.phoneChannelData.waitTime = waitTime;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withCallDuration = function (callDuration) {
        this.phoneChannelData.callDuration = callDuration;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withTimeZone = function (timeZone) {
        this.phoneChannelData.timeZone = timeZone;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withStartTime = function (startTime) {
        this.phoneChannelData.startTime = startTime;
        return this;
    };
    PhoneChannelDataBuilder.prototype.withEndTime = function (endTime) {
        this.phoneChannelData.endTime = endTime;
        return this;
    };
    PhoneChannelDataBuilder.prototype.build = function () {
        return this.phoneChannelData;
    };
    return PhoneChannelDataBuilder;
}());
export { PhoneChannelDataBuilder };
//# sourceMappingURL=phone-channel-data.builder.js.map